export default "__VITE_ASSET__DgbzFWE2__"